<template>
    <div>

        <el-select :style="{ width }"  :size="size" v-if="objUrl.tiile === '来源'" v-model="inputAcount" filterable  clearable  :placeholder="'请选择' + objUrl.tiile" :filter-method="handleChangeNameaaaa" @change="handleChange">
          <el-option v-for="item in optionsList1" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
        </el-select>

        <el-select :style="{ width }"  :size="size" v-if="objUrl.tiile === '来源负责人'" v-model="inputAcount" filterable  clearable  :placeholder="'请选择' + objUrl.tiile" :filter-method="handleChangeNameaaaa" @change="handleChange">
          <el-option v-for="item in optionsList1" :key="item.sourcepeopleId" :label="item.sourcepeopleName" :value="item.sourcepeopleId" ></el-option>
        </el-select>

        <el-select :style="{ width }" :size="size" v-if="objUrl.tiile === '老师'" v-model="inputAcount" filterable  clearable  :placeholder="'请选择IP' + objUrl.tiile" :filter-method="handleChangeNameaaaa" @change="handleChange">
          <el-option v-for="item in optionsList1" :key="item.id" :label="item.teacherName"  :value="item.id" ></el-option>
        </el-select>

    </div>
</template>


<script>
import apiBaseUrl from "../../config/api";
import axios from "axios";



export default {

  props: {
   
    objUrl: {
        type: Object,
        default: function() {
            return {};
        }
    },

    size: {
        type: String,
        default: ''
    },

    width: {
        type: String,
        default: ''
    },
    
  },
  
  data () {
    return {
        inputAcount: '',
        optionsList1: [],
    };
  },

  mounted () {
    this.handleInitViwe()
    console.log(this.objUrl)
  },

  methods: {

    childMethod() {
      this.inputAcount = ''
      this.handleInitViwe()
      this.$emit('handleChangeSelect', this.objUrl.keys, '')
    },

    handleChange(value) {
        this.$emit('handleChangeSelect', this.objUrl.keys, value)
    },

    handleChangeNameaaaa(value) {
       let name = this.objUrl.tiile === '老师' ? 'teacherName' : this.objUrl.tiile === '来源' ? 'sourceName' : this.objUrl.tiile === '来源负责人' ? 'sourcepeopleName' : ''
       axios.get(`${apiBaseUrl}${this.objUrl.selectList}?${name}=${value}`, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
         if (res.data.code == 200) {
           this.optionsList1 = this.objUrl.tiile === '老师' ? res.data.data : this.objUrl.tiile === '来源' ? res.data.data.list : this.objUrl.tiile === '来源负责人' ? res.data.data.list : []
         }else{
           this.optionsList1 = []
         }
       })
    },


    handleInitViwe(){
       let name = this.objUrl.tiile === '老师' ? 'teacherName' : this.objUrl.tiile === '来源' ? 'sourceName' : this.objUrl.tiile === '来源负责人' ? 'sourcepeopleName' : ''
       axios.get(`${apiBaseUrl}${this.objUrl.selectList}?${name}=`, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
         if (res.data.code == 200) {
           this.optionsList1 = this.objUrl.tiile === '老师' ? res.data.data : this.objUrl.tiile === '来源' ? res.data.data.list : this.objUrl.tiile === '来源负责人' ? res.data.data.list : []
         }else{
           this.optionsList1 = []
         }
       })
    },

   
  }

};
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/CustomerFundingAll/selectcomtent.vue